<div class="map-page">
  <img class="back-btn pulse-grow-on-hover" routerLinkActive="active" [routerLink]="['/shore']" src="assets/img/arrowbackward.png">
  <a class="box-page"><img src="assets/img/mapPaperView.png"></a>
  <div class="content-box">
  <google-map
    height="500px"
    width="100%"
    [zoom]="zoom"
    [center]="center"
    [options]="options"
    (mapClick)="click($event)"
    >
    <map-marker
      #markerElem
      *ngFor="let marker of markers"
      [position]="marker.position"
      [label]="marker.label"
      [title]="marker.title"
      [options]="marker.options"
      (mapClick)="openInfo(markerElem, marker.info)"
      >
    </map-marker>

    <map-info-window>{{ infoContent }}</map-info-window>
  </google-map>

<!--
  <button (click)="zoomIn()">Zoom in</button>
  <button (click)="zoomOut()">Zoom out</button>
  <button (click)="logCenter()">Log center</button>
    <button (click)="addMarker()">Add marker</button>
-->
</div>
</div>